export default __webpack_public_path__ + "static/media/uml.16bef33d.png";